import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'

import Link from 'components/widgets/Link'
import AppBarMenu from 'components/layout/AppBarMenu'
import Snackbar from '@nocode-works/template/components/system/Snackbar'
import Loading from '@nocode-works/template/components/system/Loading'
import DriveDialog from '@nocode-works/template/components/drive/Dialog'
import DriveUpgradeScopeDialog from '@nocode-works/template/components/system/DriveUpgradeRequestModal'

import userActions from 'store/modules/user'
import userSelectors from 'store/selectors/user'
import appsumoSelectors from 'store/selectors/appsumo'
import networkSelectors from '@nocode-works/template/store/selectors/network'



import userUtils from 'utils/user'

import {
  getSideMenu,
} from 'settings'

const useStyles = makeStyles(theme => {
  return {
    root: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    appbarContainer: {
      flexGrow: 0,
    },
    contentContainer: {
      flexGrow: 1,
      overflow: 'auto',
    },
    appbar: {
      backgroundColor: '#fff',
      boxShadow: 'none',
      borderBottom: '1px #dedede solid',
    },
    toolbar: {
      paddingLeft: '0px',
      paddingRight: '0px',
      backgroundColor: '#fff',
    },
    leftContainer: {
      paddingLeft: theme.spacing(3),
      flexGrow: 1,
    },
    logo: {
      height: '40px',
      marginRight: theme.spacing(2),
    },
    appsumoLogo: {
      height: '25px',
      marginRight: theme.spacing(2),
      marginBottom: '5px',
    },
    rightContainer: {
      paddingRight: theme.spacing(2),
      display: 'flex',
      alignItems: 'center',
    },
    emailContainer: {
      marginRight: theme.spacing(2),
    },
    emailText: {
      color: '#999',
    },
    headerOffset: {
      width: theme.spacing(2),
    },
    appsumoLink: {
      marginLeft: theme.spacing(2),
    },
  }
})

const Layout = ({
  route,
  children,
}) => {
  const classes = useStyles()

  const dispatch = useDispatch()
  const user = useSelector(userSelectors.data)
  const loggedIn = useSelector(userSelectors.loggedIn)
  const isAppsumo = useSelector(appsumoSelectors.isAppsumo)

  const email = userUtils.email(user)

  const handlers = {
    logout: () => dispatch(userActions.logout()),
  }

  const sideMenuItems = getSideMenu({
    loggedIn,
    user,
    handlers,
  })

  return (
    <div className={ classes.root }>
      <div className={ classes.appbarContainer }>
        <AppBar position="relative" className={ classes.appbar }>
          <Toolbar className={ classes.toolbar }>
            <div className={ classes.leftContainer }>
              <Link
                path="/"
                name="website.list"
              >
                <img
                  className={ classes.logo }
                  src="/img/nocode-logo.png"
                />
              </Link>
              {
                isAppsumo && (
                  <Link
                    path="/"
                    name="website.list"
                    className={ classes.appsumoLink }
                  >
                    <img
                      className={ classes.appsumoLogo }
                      src="/img/as-appsumo-logo-blk.png"
                    />
                  </Link>
                )
              }
            </div>
            <div className={ classes.rightContainer }>
              <div className={ classes.emailContainer }>
                <Typography className={ classes.emailText }>
                  { email }
                </Typography>
              </div>
              <AppBarMenu
                user={ user } 
                items={ sideMenuItems }
              />
            </div>
          </Toolbar>
        </AppBar>
      </div>
      <div className={ classes.contentContainer }>
        { children }
      </div>
      <Loading />
      <Snackbar />
      <DriveDialog />
      <DriveUpgradeScopeDialog />
    </div>
  )
}

export default Layout